/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lush_Wide_Slug_DrawInputs */

const en_lush_wide_slug_draw = /** @type {(inputs: Lush_Wide_Slug_DrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pre-computed results from past surveys that appear as additional rounds.`)
};

const de_lush_wide_slug_draw = /** @type {(inputs: Lush_Wide_Slug_DrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorberechnete Ergebnisse aus vergangenen Umfragen, die als zusätzliche Runden angezeigt werden.`)
};

/**
* | output |
* | --- |
* | "Pre-computed results from past surveys that appear as additional rounds." |
*
* @param {Lush_Wide_Slug_DrawInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lush_wide_slug_draw = /** @type {((inputs?: Lush_Wide_Slug_DrawInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lush_Wide_Slug_DrawInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lush_wide_slug_draw(inputs)
	return de_lush_wide_slug_draw(inputs)
});